<template>
  <div id="buyer">
    <div class="tabbar">
      <div :class="item===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index" @click="clickItem(item,index)">
        {{item}}
      </div>
    </div>
    <div class="filter">
      <div class="select_ground">
        <div class="select_data">
          <el-select v-model="value" :popper-append-to-body="false" placeholder="选择时间" @change="selectTimeChange">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select_game">
          <el-select v-model="selectGameValue" clearable :popper-append-to-body="false" placeholder="选择游戏" @change="selectGameChange">
            <el-option
              v-for="(item,index) in selectGame"
              :key="index"
              :label="item.label"
              :value="{value:item.value,label:item.label}">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="filter_search">
        <input type="text" class="filter_search_input" v-model="match" placeholder="请输入账户关键词">
        <span class="filter_search_btn" @click="clickMatch">确认</span>
      </div>
    </div>
    <div class="product_list">
      <el-table
        :data="tableData.slice((currentPage-1)*PageSize,currentPage*PageSize)"
        @row-click="tablaRowClick"
        style="width: 100%">
        <!-- 空数据 -->
        <template slot="empty">
          <div class="no_data">
            <empty-state
              title="暂无金币订单"
              description="可以调整筛选条件后再次查看"
              icon="el-icon-coin"
              :icon-size="52">
            </empty-state>
          </div>
        </template>
        <!-- 商品信息 -->
        <el-table-column
          :label="'商品信息（'+totalCount+'条）'"
          width="480">
          <template slot-scope="scope">
            <div class="product">
              <div class="product__img">
                <el-image :src="scope.row.image"></el-image>
<!--                <img v-if="scope.row.image" :src="scope.row.image" alt="">-->
<!--                <img v-else src="https://images.pxb7.com/images/equip/20220214/20220214170100_361766.png" alt="">-->
              </div>
              <div class="product_info">
                <div class="product_info_top">
                  订单号：{{ scope.row.order_no }}
                </div>
                <div class="product_info_mid">
                  <span>{{ scope.row.game_name }}</span>
                  {{ scope.row.name }}
                </div>
                <div class="product_info_bot">
                  下单时间：{{ scope.row.add_time|moments }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 购买数量 -->
        <el-table-column
          label="购买数量">
          <template slot-scope="scope">
            <div class="product_num">{{scope.row.price}}</div>
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column
          label="金额">
          <template slot-scope="scope">
            <div class="product_price">¥{{scope.row.price}}</div>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          label="状态"
          width="111">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag v-if="scope.row.billStatus == '1'" type="danger" size="medium">待付款</el-tag>
              <el-tag v-if="scope.row.billStatus == '2'" type="error" size="medium">待发货</el-tag>
              <el-tag v-if="scope.row.billStatus == '3'" type="success" size="medium">已成交</el-tag>
              <el-tag v-if="scope.row.billStatus == '4'" type="info" size="medium">已取消</el-tag>
              <el-tag v-if="scope.row.billStatus == '5'" type="warning" size="medium">已退款</el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <div class="btn_ground">
              <a v-if="scope.row.sys_service_type == 2||scope.row.sys_service_type ==3&&scope.row.billStatus!='3'" class="ask_service cust_ask" @click.stop="cusSerBtnClicks(scope.row)">咨询客服</a>
              <a v-if="scope.row.sys_service_type != 2&&scope.row.billStatus!='3'" class="ask_service cust_ask" @click.stop="$accessLink(scope.row.game_customer)" :href="`${scope.row.game_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`" target="_blank">咨询客服</a>
              <a
                class="ask_service"
                v-if="scope.row.billStatus=='2'||scope.row.billStatus=='3'||scope.row.billStatus=='5'"
                @click="goDetail(scope.row)"
                href="#">支付详情</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages" v-if="totalCount !== 0">
        <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="PageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount">
        </common-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {apiGameList,apiBuyGoldList} from "@/request/API";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: '',
  props: {
  },
  components: {
    CommonPagination,
    EmptyState
  },
  data () {
    return {
      // 默认显示第几页
      currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount:0,
      // 默认每页显示的条数（可修改）
      PageSize:10,
      // tabbar 选中项
      selectItem:'全部订单',
      // tabbar 选中项Index
      selectItemIndex: 0,
      tabbarItem:[
        '全部订单','待付款','待发货','已成交','已取消','已退款'
      ],
      //表格数据
      tableData: [],
      //选择时间下拉框
      options: [
        {value: '0', label: '全部'},
        {value: '1', label: '本周内'},
        {value: '2', label: '当月'},
        {value: '3', label: '三个月内'},
        {value: '4', label: '半年内'},
        {value: '5', label: '半年以上'},
        {value: '6', label: '一年内'},
      ],
      value: '',
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: '',
      //关键词搜索
      match:'',
      //当前页码
      page:1
    }
  },
  methods: {
    /**
     * @description: 跳转支付详情
     * @return {*}
     */
    goDetail(row) {
      this.$router.push({
        name: 'BuyerDetail',
        query: {info:row.id}
      })
    },
    cusSerBtnClicks(item) {
      this.$openIM({
        game_id: item.game_id,
        gameAlias: item.game_alias,
      })
    },
    //table监听事件
    handleEdit(index, row) {
    },
    handleCurrentChange(val) {

    },
    //表格 row 单击事件
    tablaRowClick(row, column, event){
      this.$router.push({
        name:'GoldDetails',
        query:{
          game_id:row.game_id,
          id:row.product_id
        }
      });
    },
    //tabbar
    clickItem(item, index) {
      //游戏列表  下拉框
      apiGameList({
      }).then(res=>{
        res.data.forEach((item,index)=>{
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      this.selectItem = item
      this.selectItemIndex = index
      this.getAccountList(this.value,this.selectGameValue.value,this.match,this.selectItemIndex)
    },
    //选择时间 下拉框 监听
    selectTimeChange(){
      this.getAccountList(this.value,this.selectGameValue.value,this.match,this.selectItemIndex)
    },
    //选择游戏 下拉框 监听
    selectGameChange(event){
      this.getAccountList(this.value,this.selectGameValue.value,this.match,this.selectItemIndex)
    },
    //关键词搜索
    clickMatch(){
      this.getAccountList(this.value,this.selectGameValue.value,this.match,this.selectItemIndex)
    },
    /**
     * 获取已成交账号列表
     * @param timeType 时间下拉框
     * @param game_id  游戏下拉框
     * @param match    关键词
     */
    getAccountList(timeType,game_id,match,billStatus){
      apiBuyGoldList({
        timeType:timeType,
        game_id:game_id,
        match:match,
        billStatus:billStatus
      }).then(res=>{
        this.tableData = res.data.list
        this.totalCount = res.data.total
      })
    },
    //初始化数据
    onLoad(){
      //游戏列表  下拉框
      apiGameList({
      }).then(res=>{
        res.data.forEach((item,index)=>{
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      // 已成交 账号列表
      apiBuyGoldList({
        billStatus:'0'
      }).then(res=>{
        this.tableData = res.data.list
        this.totalCount = res.data.total
      })
    }
  },
  mounted () {
    //初始化数据
    if(typeof(this.$route.params.selectItem) !== 'undefined'){
      this.clickItem(this.$route.params.selectItem,this.$route.params.selectItemIndex)
    }else {
      this.onLoad()
    }
  },
  watch: {

  },
  computed: {

  }
}
</script>

<style lang='less'>
.change_price_confirm{
  width: 500px !important;
  min-height: 300px !important;
  height: auto !important;
  background: var(--bg-card, #FFFFFF) !important;
  border-radius: 4px !important;
  padding: 0;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-message-box__header>.el-message-box__title{
    display: none;
  }

  .el-message-box__header,
  .el-message-box__content{
    display: flex;
    flex-direction: column;
    padding: 0 64px;
  }

  .el-message-box__btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 0 34px;
  }

  .el-message-box__title{
    margin-top: 34px;
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: var(--text-main, #111827);
    line-height: 28px;
  }

  .el-message-box__container{
    margin-top: 32px;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
  }

  .change_price_confirm_btn{
    padding: 0;
    width: 180px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 4px;
    border: none;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF !important;
    box-shadow: none;
    transition: opacity .2s ease, box-shadow .2s ease, background .2s ease;
  }

  .change_price_confirm_btn:hover{
    opacity: 1;
    background: var(--primary-hover, #E84A12) !important;
    box-shadow: 0 10px 22px rgba(255, 90, 31, 0.22);
  }

  .confirm_content{
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price{
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 600;
    color: var(--primary, #FF7A1A);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_my_bid{
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
  }

  .confirm_modify_bid_text{
    flex: 0 0 auto;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
  }

  .confirm_modify_bid_input{
    width: 220px;
    height: 40px;
    background: var(--bg-tag, #F7F5F2);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    padding: 0 14px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    line-height: 22px;
    outline: none;
    transition: border-color .2s ease, box-shadow .2s ease;
  }

  .confirm_modify_bid_input:focus{
    border-color: var(--primary, #FF5A1F);
    box-shadow: none;
  }

  .confirm_modify_bid_tips{
    margin: 10px 0 0 78px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-muted, #9AA0AC);
    line-height: 20px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-muted, #9AA0AC);
  }
}
</style>

<style lang='less' scoped>
#buyer{
  padding: 20px;
  display: flex;
  flex-direction: column;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after{
    box-sizing: border-box;
  }

  .tabbar{
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    overflow: visible;
    background: transparent;
    border: none;
    border-radius: 0;

    div{
      min-width: 84px;
      height: 34px;
      margin-right: 0;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    div:hover{
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .isAcitve{
      padding-bottom: 0;
      font-size: 14px;
      font-weight: 500;
      color: #FFFFFF;
      background: var(--bg-dark, #1A1D24);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
      border-bottom: 3px solid var(--primary, #FF5A1F);
    }

    .isAcitve:hover{
      color: #FFFFFF;
      background: var(--bg-dark, #1A1D24);
    }

    div:last-of-type{
      margin: 0;
    }
  }

  .filter{
    min-height: 40px;
    height: auto;
    margin: 18px 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;

    .select_ground{
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;

      /deep/.el-input__inner{
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/.el-input.is-focus .el-input__inner,
      /deep/.el-input__inner:focus{
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/.popper__arrow{
        left: 155px !important;
      }

      /deep/.el-select-dropdown{
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/.el-select-dropdown__item{
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/.el-select-dropdown__item.hover,
      /deep/.el-select-dropdown__item:hover{
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/.el-select-dropdown__item.selected{
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }

      .select_data{
        margin-right: 0;
      }
    }

    .filter_search{
      width: 318px;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      position: static;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      transition: border-color .2s ease, box-shadow .2s ease;

      &:focus-within{
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .filter_search_input{
        width: 100%;
        min-width: 0;
        height: 38px;
        padding: 0 16px;
        background: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: var(--text-main, #111827);
      }

      .filter_search_input::-webkit-input-placeholder{
        font-size: 14px;
        color: var(--text-muted, #9AA0AC);
      }

      .filter_search_btn{
        position: static;
        width: 92px;
        height: 32px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: var(--primary, #FF5A1F);
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
        box-shadow: none;
        transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
      }

      .filter_search_btn:hover{
        opacity: 1;
        background: var(--primary-hover, #E84A12);
      }
    }
  }

  .product_list{
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    /deep/.el-table{
      color: var(--text-main, #111827);
    }

    /deep/.el-table:before{
      display: none;
    }

    /deep/.el-table th{
      height: 48px;
      background: var(--bg-tag, #F7F5F2);
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-secondary, #5A5F6B);
    }

    /deep/.el-table th>.cell{
      text-align: center;
    }

    /deep/.el-table .cell{
      padding: 0;
      text-align: center;
      overflow: visible;
    }

    /deep/.el-table td{
      padding: 0;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
    }

    /deep/.el-table__row{
      transition: background .2s ease;
    }

    /deep/.el-table__row:hover{
      cursor: pointer;

      td{
        background: var(--bg-tag, #F7F5F2);
      }
    }

    /deep/.el-tag{
      height: 28px;
      padding: 0 10px;
      display: inline-flex;
      align-items: center;
      border: none;
      border-radius: 4px;
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-main, #1A1D24);
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
    }

    /deep/.el-tag.el-tag--danger,
    /deep/.el-tag.el-tag--error{
      background: var(--primary-soft, #FCEDE5);
      color: var(--gold, #C9974D);
    }

    /deep/.el-tag.el-tag--info{
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-muted, #9AA0AC);
    }

    /deep/.el-tag.el-tag--success{
      background: var(--success-soft, #ECFDF5);
      color: var(--new, #00C16E);
    }

    /deep/.el-tag.el-tag--warning{
      background: #FFE9ED;
      color: var(--hot, #FF2D55);
    }

    .name-wrapper{
      min-height: 28px;
    }

    .product{
      height: 168px;
      padding: 18px 0 18px 18px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .product__img{
      width: 124px;
      height: 124px;
      margin-right: 18px;
      flex: 0 0 124px;
      overflow: hidden;
      background: var(--bg-tag, #F0EDE8);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;

      img,
      /deep/.el-image{
        height: 100%;
        width: 100%;
        display: block;
        object-fit: cover;
        border-radius: 0;
      }
    }

    .product_info{
      width: 320px;
      height: 124px;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .product_info_top{
      min-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 22px;
      text-align: left;
    }

    .product_info_mid{
      height: 52px;
      display: -webkit-box;
      overflow: hidden;
      text-align: left;
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      line-height: 26px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      span{
        max-width: 120px;
        height: 22px;
        margin: 1px 6px 0 0;
        padding: 2px 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: top;
        white-space: nowrap;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: var(--text-main, #1A1D24);
        line-height: 18px;
        background: var(--bg-tag, #F0EDE8);
        border-radius: 4px;
      }
    }

    .product_info_bot{
      min-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-muted, #9AA0AC);
      line-height: 22px;
      text-align: left;
    }

    .product_num{
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      line-height: 22px;
    }

    .product_price{
      font-size: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 600;
      color: var(--primary, #FF7A1A);
      line-height: 28px;
    }

    .my_bid{
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 80px;
      color: var(--text-muted, #9AA0AC);

      .my_bid_text{
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        margin-bottom: 10px;
        line-height: 20px;
      }

      .my_bid_date{
        width: 85px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
        line-height: 18px;
      }
    }

    .btn_ground{
      min-height: 74px;
      padding: 8px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 8px;

      div,
      a{
        min-width: 82px;
        height: 30px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
        transition: border-color .2s ease, box-shadow .2s ease, opacity .2s ease, background .2s ease, color .2s ease;
      }

      div:hover,
      a:hover{
        opacity: .92;
      }

      .ask_service{
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border: 1px solid transparent;
        box-shadow: none;
      }

      .ask_service:hover{
        background: var(--primary-hover, #E84A12);
        opacity: 1;
      }

      .cust_ask{
        color: var(--text-main, #1A1D24);
        background: var(--bg-card, #FFFFFF);
        border: 1.5px solid var(--bg-dark, #1A1D24);
        box-shadow: none;
      }

      .cust_ask:hover{
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
        border-color: var(--bg-dark, #1A1D24);
      }

      .agree_state{
        display: flex;
        flex-direction: column;
        height: 50px;
        align-items: center;

        img{
          width: 26px;
          height: 26px;
          object-fit: cover;
          margin-bottom: 2px;
        }

        .state_text{
          font-size: 13px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          line-height: 20px;
        }
      }

      .refuse_state{
        display: flex;
        flex-direction: column;
        height: 50px;
        align-items: center;
        margin: 0 0 12px 0;

        img{
          width: 26px;
          height: 26px;
          object-fit: cover;
          margin-bottom: 2px;
        }

        .state_text{
          font-size: 13px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          line-height: 20px;
        }
      }
    }

    .pages{
      min-height: 88px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg-card, #FFFFFF);
    }

    .no_data{
      min-height: 300px;
      padding: 64px 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
